import React, {useState} from 'react';
import Navbar from '../../../common/navbar';
import AdminSidebar from '../dashboard/adminSidebar';
import UserManagement from './userManagement';
import BroadbeanUsers from './broadbeanUsers';
import Breadcrumb from "../breadCrumb";
import Entities from './entities';
import AdminDashboardContent from './adminDashboardContent';
import {UsersRound,UserRoundCheck,BriefcaseBusiness,UserRoundPlus,Database } from 'lucide-react';



const AdminDashboard = () => {
      const [activeSection, setActiveSection] = useState("dashboard");
      const [isCreateUser, setIsCreateUser] = useState(false);

        const setRouting = (value) => {
        if (value === "user") {
            setActiveSection("userManagement");
            // when routing from the dashboard to user area, treat as "create user" flow
            setIsCreateUser(false);
            // reset the flag shortly after so child can open modal once
            // setTimeout(() => setIsCreateUser(false), 200);
        } else {
            setActiveSection("entities");
            setIsCreateUser(false);
        }
        
    };
    return (
        <div className="w-full h-screen flex flex-col main-background">
            <div className="fixed top-0 left-0 right-0 z-50">
                <Navbar />
            </div>

            <div className="flex flex-1 mt-[70px] overflow-hidden">
                <div className='border'>
                    <AdminSidebar  activeSection={activeSection} onSelect={setActiveSection}/>
                </div>

                <div className="flex-1 overflow-hidden flex flex-col">
                    <div className='hidden'>
                    <Breadcrumb activeSection={activeSection} subSection={activeSection === "userManagement" && isCreateUser ? "Create User" : null}
                        onNavigate={(id) => {
                            if (id === "dashboard") {
                                setActiveSection("dashboard");
                                setIsCreateUser(false);
                            } else if (id === "user-management") {
                                setIsCreateUser(false);
                            } else {
                                setActiveSection(id);
                            }
                        }}
                    />
                    </div>
                    {activeSection === "dashboard" && (
                        <>
                            <AdminDashboardContent onActionSelect={setRouting}></AdminDashboardContent>

                        </>

                    )}            
                    {activeSection === "userManagement" && <UserManagement isCreateUser={isCreateUser} />}
                    {activeSection === "broadbeanUsers" && <BroadbeanUsers />}
                    {activeSection === "entities" && <Entities />}
                </div>

            </div>
        </div>
    );
}

export default AdminDashboard;